<template>
    <div>
        Dashboard
    </div>
</template>

<script>
export default {
    name: "Dashboard",
    created() {
        this.$router.push(
            {
                name: 'demands'
            }
        );
    }
};
</script>
